// project import
import pages from './pages';
import dashboard from './dashboard';
import utilities from './utilities';
import support from './support';
import adminpages from "./adminpages";

// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
  //items: [dashboard, pages, utilities, support]
  items: [adminpages]
};

export default menuItems;
